import { createAsyncThunk } from '@reduxjs/toolkit';
import { ApiResponse } from '@custom/Utils/constants/interfaces';
import { _stripe_gateway } from '@custom/Utils/constants/apiUrls';

const createStripePortalSession = createAsyncThunk('createStripePortalSession', async (value:any,{rejectWithValue}) => {

  const token = sessionStorage.getItem('token') || localStorage.getItem('token');

  try {
    let response = await fetch(_stripe_gateway.createPortalSession, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
         Authorization: `Bearer ${token}`,
      },
      body : JSON.stringify(value)
    })
    const data: ApiResponse<any> = await response.json();
    if(response.status >= 200){
      // @ts-ignore
      window.location.href = data.url;
    }
    else{
      rejectWithValue('Failed to fetch')
      return rejectWithValue(data);
    }
  } catch (error) {
    return error;
  }
});

export default createStripePortalSession;
